module.exports = __webpack_public_path__ + "media/images/menu/ara-2903697b982c2c4228e100892ae74e1e.jpg";